import React from 'react'
import {
  Button as BootstrapButton,
  ButtonProps as BootstrapButtonProps,
  Spinner,
} from 'react-bootstrap'

export interface ButtonProps extends BootstrapButtonProps {
  loading?: boolean
  loadingText?: React.ReactNode // text to display when button is loading
  label?: React.ReactNode
}

export const Button: React.SFC<ButtonProps> = (props) => {
  const { loading, ...rest } = props

  return (
    <BootstrapButton {...rest} disabled={loading ? true : props.disabled}>
      {loading ? (
        <>
          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
          {props.loadingText && <span style={{ marginLeft: '0.5em' }}>{props.loadingText}</span>}
        </>
      ) : (
        props.label || props.children
      )}
    </BootstrapButton>
  )
}
